import { render, staticRenderFns } from "./RevenuesTypeDelete.vue?vue&type=template&id=46a9cb62&"
import script from "./RevenuesTypeDelete.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports